import React from "react";
import { Container, Table } from "reactstrap";
import { useCurrentUser } from "~/context/current-user";

export default function SessionPage() {
  const user = useCurrentUser();

  if (!user) {
    return (
      <Container className="mt-4">
        <h1>Session</h1>
        <p>Loading...</p>
      </Container>
    );
  }

  return (
    <Container className="mt-4">
      <h1>Session</h1>
      <Table bordered className="mt-3">
        <tbody>
          <tr>
            <th>Email</th>
            <td>{user.email}</td>
          </tr>
          <tr>
            <th>Name</th>
            <td>{user.name}</td>
          </tr>
          {/* TODO(rbac): this "current roles" view is the natural home for
              effective-role controls (enforced server-side in
              server/api/route.ts `assertRole`):
              - Escalation: start each session read-only and let the user step
                up to Basic/Privileged here before performing writes.
              - View-as: let the user cap their effective role to a lower one to
                preview what a lesser-privileged operator can see/do. */}
          <tr>
            <th>Groups</th>
            <td>
              {user.groups.length > 0 ? (
                <ul className="mb-0 ps-3">
                  {user.groups.map((g) => (
                    <li key={g}>{g}</li>
                  ))}
                </ul>
              ) : (
                <em>none</em>
              )}
            </td>
          </tr>
        </tbody>
      </Table>
    </Container>
  );
}
